let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("9FFAj")]).then(() => parcelRequire('jW3wg'));